import React from "react";
// Import Link
import { Link } from "react-router-dom";
// import Img
import Img from "../../../assets/img/common/abour_right.png";

const AboutArea = () => {
  return (
    <>
      <section id="about_us_top" className="section_padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="about_us_left">
                {/* <h5>About us</h5> */}
                <h1>About House of Polani</h1>
                <p>
                  House of Polani's journey began in 1973, establishing itself
                  as a premier IATA-accredited travel management company. What
                  started as a single-segment venture has flourished into a
                  leading Group of Companies, with a commanding presence across
                  Pakistan and international offices in London. Our growth story
                  is marked by dedication, innovation, and an unwavering
                  commitment to excellence, resulting in an annual turnover
                  exceeding 6 Billion PKR.
                </p>
                <p>
                  Today, our reach extends globally through our strategic
                  offices in Karachi, Islamabad, and London. With a professional
                  workforce of over 150 qualified experts, we've built strong
                  partnerships with major airlines, hotels, and travel providers
                  worldwide. Our comprehensive service portfolio encompasses
                  everything from corporate travel management to specialized
                  religious tours, making us a one-stop solution for all travel
                  needs.{" "}
                </p>
                {/* <Link to="#!" className="btn btn_theme btn_sm">
                  More
                </Link> */}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about_us_right">
                <img src={Img} alt="img" />
              </div>
            </div>
          </div>
          <br></br>
          <div className="row">
            <div className="col-lg-6">
              <div className="about_us_left">
                {/* <h5>About us</h5> */}
                <h2>Why House of Polani?</h2>
                <p>
                  Why House of Polani? The transformation from a modest travel
                  agency to a market leader spanning five decades stands
                  testament to our dedication and vision. Under the able
                  leadership of Mr. Tariq Polani, we've not only expanded our
                  service offerings but have revolutionized the way travel
                  management is perceived in Pakistan. Our success isn't
                  measured merely by our turnover but by the trust we've earned
                  from thousands of satisfied clients.
                </p>
                <p>
                  {" "}
                  Our strength lies in our diverse expertise – from handling
                  complex corporate travel arrangements to organizing spiritual
                  journeys for Hajj and Umrah. We maintain excellent
                  relationships with various government departments, airlines,
                  and industry stakeholders, ensuring smooth operations and
                  superior service delivery for our clients.{" "}
                </p>
                {/* <Link to="#!" className="btn btn_theme btn_sm">
                  More
                </Link> */}
              </div>
            </div>

            <div className="col-lg-6">
              <div className="about_us_left">
                {/* <h5>About us</h5> */}
                <h2>Our Professional Excellence</h2>
                <p>
                  At House of Polani, professionalism isn't just a buzzword –
                  it's deeply ingrained in our corporate DNA. Our team of travel
                  experts undergoes regular training to stay ahead of industry
                  trends and technological advancements. We've invested heavily
                  in cutting-edge travel management systems, ensuring that our
                  clients receive the most efficient and innovative solutions
                  available in the market.
                </p>
                <p>
                  Every member of our team is committed to upholding the highest
                  standards of service excellence. Whether it's processing visa
                  applications, arranging corporate events, or planning personal
                  vacations, we approach each task with meticulous attention to
                  detail and unwavering dedication.{" "}
                </p>
                {/* <Link to="#!" className="btn btn_theme btn_sm">
                  More
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutArea;
